import { render, staticRenderFns } from "./ConfigLinkedRevenueItem.vue?vue&type=template&id=48061324&scoped=true&"
import script from "./ConfigLinkedRevenueItem.vue?vue&type=script&lang=js&"
export * from "./ConfigLinkedRevenueItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLinkedRevenueItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConfigLinkedRevenueItem.vue?vue&type=style&index=1&id=48061324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48061324",
  null
  
)

export default component.exports